import React from 'react';
import classes from './ExaminationAudio.module.css';
import { MediaPlayer } from '../UI/AudioPlayer/MediaPlayer';

type Props = {
  attachments: string[];
  date?: Date;
  image?: string;
};

const ExaminationAudio: React.FC<Props> = ({ attachments, date, image }) => {
  return (
    <div>
      <div className={`${classes.container} ${image ? '' : classes.noImageContainer}`}>
        {image && (
          <div className={classes.imageContainer}>
            <img alt={'examination-pic'} src={image} className={classes.image} />
          </div>
        )}
        <div className={`${classes.audioContainer}`}>
          {attachments.map((att, index) => (
            <div key={index} className={classes.audio}>
              <div className={classes.audioText}>Point {index + 1}</div>
              <MediaPlayer mediaType="audio" url={att} urlType="attachment" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { ExaminationAudio };
